module.exports = __webpack_public_path__ + "static/media/my-designs.182b4a89.svg";